// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__1-OR9","navText":"Navbar_navText__2qm2j","navLogo":"Navbar_navLogo__2ypJg","imgLogo":"Navbar_imgLogo__1WVmQ"};